import { useQuery } from "@apollo/client";
import { FiPlus } from "react-icons/fi";
import Button from "components/base/Button";
import Errors from "components/base/Errors";
import Page from "components/base/Page";
import Spinner from "components/base/Spinner";
import { useModals } from "ModalProvider";
import MarketingMaterialCard from "./MarketingMaterialCard";
import MarketingMaterialFormModal from "./MarketingMaterialFormModal";
import { FETCH_ALL_MARKETING_MATERIALS } from "./graphql";

function MarketingPage() {
  const modal = useModals();
  const { loading, error, data, refetch } = useQuery(FETCH_ALL_MARKETING_MATERIALS);

  const handleCreateMaterial = () => {
    modal.present({
      maxWidth: "max-w-4xl",
      center: true,
      children: (
        <MarketingMaterialFormModal
          refetch={refetch}
          hide={modal.hide}
        />
      ),
    });
  };

  const handleEditMaterial = (material) => {
    modal.present({
      maxWidth: "max-w-4xl",
      center: true,
      children: (
        <MarketingMaterialFormModal
          material={material}
          refetch={refetch}
          hide={modal.hide}
        />
      ),
    });
  };

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  return (
    <Page
      title="Marketing"
      rightButtons={
        <div className="flex items-center gap-3">
          <Button onClick={handleCreateMaterial}>
            <span className="flex items-center">
              <FiPlus className="mr-2" />
              Create Material
            </span>
          </Button>
        </div>
      }
    >
      <div className="m-6">
        <div className="opacity-70 space-y-2">
          <p>
            Please directly click the button on the top right to upload cover
            image and material files.
          </p>
        </div>
      </div>

      <div className="my-6 flex-1">
        <div className="container mx-auto px-6 md:px-12 lg:px-24">
          <div className="mb-6">
            <h2 className="text-xl font-bold text-gray-800 tracking-wide">
              Logo
            </h2>
          </div>

          {(data?.allMarketingMaterials || []).length === 0 ? (
            <div className="text-sm text-gray-400 py-3">No materials yet.</div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
              {(data?.allMarketingMaterials || []).map((material) => (
                <MarketingMaterialCard
                  key={material.id}
                  material={material}
                  onClick={() => handleEditMaterial(material)}
                />
              ))}
            </div>
          )}
        </div>
      </div>
    </Page>
  );
}

export default MarketingPage;
